import Contract from "domain/contract";
import useUnitConversionRates from "./useUnitConversionRates";
import unitHelper from "domain/unitHelper";

interface IUnitHelperHook {
    forContract(contract: Contract): IContractBaseUnitHelper;
}

interface IContractBaseUnitHelper {
    getQuantity(quantity: number, precision?: number): number;
    getQuantityText(quantity: number, precision?: number): string;
}



export default function useUnitHelper(): IUnitHelperHook {
    const unitConversionRates = useUnitConversionRates();

    function getContractUnitHelper(contract: Contract): IContractBaseUnitHelper {
        return {
            getQuantity: (quantity: number, precision?: number) => unitHelper.getQuantity(quantity, contract.commodity, unitConversionRates, precision),
            getQuantityText: (quantity: number, precision?: number) => unitHelper.getQuantityTextWithUnits(quantity, contract.commodity, unitConversionRates, precision)
        }
    }

    return {
        forContract: (contract: Contract) => getContractUnitHelper(contract)
    };
}